import SolarIcon from 'components/icons/SolarIcon';
const WidgetColorNumber = ({variant = 'primary', infoNum='', infoText='', 
        iconJsx=(<SolarIcon name="brightness-high-fill" />)}) => {
    return (
        <div className="col-md-6 col-xl-3">
            <div className={`card social-widget-card dashboard-status-card bg-${variant}`}>
                <div className="card-body d-flex align-items-center justify-content-between gap-3">
                    <div className="dashboard-status-card__content">
                        <h3 className="text-white m-0">{infoNum||'-'}</h3>
                        <span className="m-t-10">{infoText}</span>
                    </div>
                    <div className="dashboard-status-card__icon text-white" aria-hidden="true">
                        {iconJsx}
                    </div>
                </div>
            </div> 
        </div>
    );
};

export default WidgetColorNumber;
